import { isEmpty, isNil } from 'lodash';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslator } from '~frontend-common/i18n/translator';
import { FrontendWebPortalConfig } from '~web-portal/config';
import { useAuthStore, useUserStore } from '~web-portal/stores';

export function HelpScoutBeacon() {
  const isLoggedIn = useAuthStore.use.isLoggedIn()();
  const user = useUserStore.use.user();

  const translator = useTranslator();

  // Init / destroy
  useEffect(() => {
    if (isEmpty(FrontendWebPortalConfig.helpScoutBeaconId)) {
      return;
    }

    if (isLoggedIn) {
      window.Beacon?.('init', FrontendWebPortalConfig.helpScoutBeaconId);
    } else {
      window.Beacon?.('destroy');
    }
  }, [isLoggedIn]);

  // Identify
  useEffect(() => {
    if (isEmpty(FrontendWebPortalConfig.helpScoutBeaconId) || !isLoggedIn || isNil(user)) {
      return;
    }

    const fullname = [user.firstName, user.lastName].filter((name) => !isEmpty(name)).join(' ');

    window.Beacon?.('identify', { name: fullname, email: user.email });

    const labels: Record<string, string> = translator.i18n.t('helpScoutBeacon.labels', {
      returnObjects: true,
      // Force language, otherwise we might get a race condition, since the translator needs more time to update the language
      lng: user.language,
    });
    window.Beacon?.('config', { labels });
  }, [isLoggedIn, user]);

  if (isEmpty(FrontendWebPortalConfig.helpScoutBeaconId)) {
    return null;
  }

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          !(function (e, t, n) {
            function a() {
              var e = t.getElementsByTagName('script')[0],
                n = t.createElement('script');
              (n.type = 'text/javascript'),
                (n.async = !0),
                (n.src = 'https://beacon-v2.helpscout.net'),
                e.parentNode.insertBefore(n, e);
            }
            if (
              ((e.Beacon = n =
                function (t, n, a) {
                  e.Beacon.readyQueue.push({ method: t, options: n, data: a });
                }),
              (n.readyQueue = []),
              'complete' === t.readyState)
            )
              return a();
            e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);
          })(window, document, window.Beacon || function () {});
      `}
      </script>
    </Helmet>
  );
}
